export const OTHER_SOCIAL_CONTROL_OPTION_ID = '__OTHER__';

export const SOCIAL_CONTROL_LINE_VALUES = {
  CONTROL_SOCIAL: 'Control Social a la Gestión Pública',
  TRANSPARENT_MANAGEMENT: 'Gestión Transparente'
};

export const SOCIAL_CONTROL_LINES = [
  {
    id: SOCIAL_CONTROL_LINE_VALUES.CONTROL_SOCIAL,
    name: SOCIAL_CONTROL_LINE_VALUES.CONTROL_SOCIAL
  },
  {
    id: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT,
    name: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  }
];

export const SOCIAL_CONTROL_ORGANIZATION_TYPES = [
  { id: 'VC', name: 'Veedurías ciudadanas' },
  { id: 'MCS', name: 'Modalidades de control social' },
  {
    id: 'IPC',
    name: 'Instancias de participación ciudadana'
  },
  { id: 'OS', name: 'Organizaciones sociales' },
  { id: 'OC', name: 'Organismos comunales' },
  { id: 'IE - CS', name: 'Instituciones educativas' },
  {
    id: 'IES',
    name: 'Instituciones de Educación Superior'
  },
  {
    id: 'JAL',
    name: 'Juntas Administradoras Locales'
  },
  { id: OTHER_SOCIAL_CONTROL_OPTION_ID, name: 'Otro' }
];

export const SOCIAL_CONTROL_ACTIVITIES = [
  {
    id: 'Control Social con jóvenes',
    name: 'Control Social con jóvenes',
    organization: SOCIAL_CONTROL_LINE_VALUES.CONTROL_SOCIAL
  },
  {
    id: 'Veedores por la Transparencia',
    name: 'Veedores por la Transparencia',
    organization: SOCIAL_CONTROL_LINE_VALUES.CONTROL_SOCIAL
  },
  {
    id: 'Curso RIAV',
    name: 'Curso RIAV',
    organization: SOCIAL_CONTROL_LINE_VALUES.CONTROL_SOCIAL
  },
  {
    id: 'Planes de Control Social',
    name: 'Planes de Control Social',
    organization: SOCIAL_CONTROL_LINE_VALUES.CONTROL_SOCIAL
  },
  {
    id: 'Promoción Control Social a la Gestión Pública',
    name: 'Promoción Control Social a la Gestión Pública',
    organization: SOCIAL_CONTROL_LINE_VALUES.CONTROL_SOCIAL
  },
  {
    id: 'Encuentro Pedagógico Control Social a la Gestión Pública',
    name: 'Encuentro Pedagógico Control Social a la Gestión Pública',
    organization: SOCIAL_CONTROL_LINE_VALUES.CONTROL_SOCIAL
  },
  {
    id: 'Formación Rendición Social de Cuentas',
    name: 'Formación Rendición Social de Cuentas',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Asesorías Rendición Social de Cuentas',
    name: 'Asesorías Rendición Social de Cuentas',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Acompañamiento Rendición Social de Cuentas',
    name: 'Acompañamiento Rendición Social de Cuentas',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Socialización de resultados y certificación Rendición Social de Cuentas',
    name: 'Socialización de resultados y certificación Rendición Social de Cuentas',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Formación Rendición Pública de Cuentas JAL',
    name: 'Formación Rendición Pública de Cuentas JAL',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Asesoría Rendición Pública de Cuentas JAL',
    name: 'Asesoría Rendición Pública de Cuentas JAL',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Acompañamiento Rendición Pública de Cuentas JAL',
    name: 'Acompañamiento Rendición Pública de Cuentas JAL',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Socialización de resultados y certificación Rendición Pública de Cuentas JAL',
    name: 'Socialización de resultados y certificación Rendición Pública de Cuentas JAL',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Promoción Control Social a Presupuesto Participativo PP',
    name: 'Promoción Control Social a Presupuesto Participativo PP',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Promoción Gestión Transparente',
    name: 'Promoción Gestión Transparente',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  {
    id: 'Encuentro Pedagógico Gestión Transparente',
    name: 'Encuentro Pedagógico Gestión Transparente',
    organization: SOCIAL_CONTROL_LINE_VALUES.TRANSPARENT_MANAGEMENT
  },
  { id: OTHER_SOCIAL_CONTROL_OPTION_ID, name: 'Otro' }
];

export function getSocialControlOrganizationForActivity(activityId) {
  return (
    SOCIAL_CONTROL_ACTIVITIES.find(
      activity => String(activity.id) === String(activityId)
    )?.organization || ''
  );
}

export function resolveSocialControlCatalogValue(selectedValue, otherValue) {
  return selectedValue === OTHER_SOCIAL_CONTROL_OPTION_ID
    ? String(otherValue || '').trim()
    : String(selectedValue || '').trim();
}

export function getSocialControlOrganizationTypeLabel(value) {
  const normalizedValue = String(value || '').trim();
  if (!normalizedValue) return '';

  const normalizedUpperValue = normalizedValue.toUpperCase();
  const organizationTypeAliases = {
    IE: 'IE - CS'
  };
  const normalizedLookupValue =
    organizationTypeAliases[normalizedUpperValue] || normalizedUpperValue;
  const option = SOCIAL_CONTROL_ORGANIZATION_TYPES.find(item => {
    if (item.id === OTHER_SOCIAL_CONTROL_OPTION_ID) return false;

    return (
      String(item.id).toUpperCase() === normalizedLookupValue ||
      String(item.name).toUpperCase() === normalizedUpperValue
    );
  });

  return option?.name || normalizedValue;
}

export function buildSocialControlSchoolPayload({
  organizationName,
  type,
  activity,
  organization,
  municipality,
  neighborhood,
  facilitator,
  year = new Date().getFullYear().toString()
}) {
  return {
    name: String(organizationName || '').trim(),
    type: String(type || '').trim(),
    address: String(activity || '').trim(),
    municipality: Number(municipality),
    neighborhood: Number(neighborhood),
    organization: String(organization || '').trim(),
    facilitator: Number(facilitator),
    resourceType: 'RO',
    year: String(year),
    groups: [],
    active: true
  };
}
